import { Component, ElementRef, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { switchMap, tap } from "rxjs/operators";
import { Page } from "src/app/util/page";
import { InventoryMovement } from "../model/inventory-movement";
import { ProductSynchronization } from "../model/product-synchronization";
import { ShopifyService } from "../shopify-service";

@Component({
  selector: "shopify-overview",
  styleUrls: ["./shopify-overview.component.css"],
  templateUrl: "./shopify-overview.component.html"
})
export class ShopifyOverviewComponent {
  @ViewChild('modal') modalRef!: ElementRef;

  inventoryMovementsPage!: Page<InventoryMovement>
  lastSynchronization!: Date;
  productsPage!: Page<ProductSynchronization>;
  errorToDisplay!: string;

  constructor(
    private modalService: NgbModal,
    private shopifyService: ShopifyService,
  ) {
    this.refreshData();
  }

  openErrorMessage(errorToDisplay: string) {
    this.errorToDisplay = errorToDisplay;

    this.modalService.open(this.modalRef, {
      size: "xl"
    });
  }

  private refreshData() {
    this.shopifyService.findProductSynchronizationsByStatusIn(["TO_PROCESS", "ERROR"], 0, "creationTimestamp,ASC")
      .pipe(tap(page => this.productsPage = page))
      .pipe(switchMap(_ => this.shopifyService.findInventoryMovementsByStatusIn(["TO_PROCESS", "ERROR"], 0, "creationTimestamp,ASC")))
      .pipe(tap(page => this.inventoryMovementsPage = page))
      .pipe(switchMap(_ => this.shopifyService.findLastSynchronization()))
      .pipe(tap(lastSynchronization => this.lastSynchronization = lastSynchronization))
      .pipe(tap(_ => setTimeout(() => this.refreshData(), 5000)))
      .subscribe();
  }

  retryErrors() {
    this.shopifyService.retryErrors().subscribe({
      complete: () => this.refreshData()
    });
  }
}